export default __webpack_public_path__ + "static/media/ArgyllFerries.9a7eb8c2.webp";